import styled from "styled-components";
import {
  BORDER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import { COMPONENTS, SPACING } from "../../constants/design/spacing";

export const ShareContainer = styled.button`
  margin-right: ${SPACING.one}px;
`;

export const AssetAndLabels = styled.div`
  display: flex;
  align-items: center;
  > span:first-child {
    margin-right: ${SPACING.two}px;
  }

  > div {
    display: flex;
    flex-direction: column;

    span {
      ${FONT_CSS.body.six}
      color: ${TEXT_COLORS.three};
    }

    span:first-child {
      ${FONT_CSS.body.five}
      color: ${TEXT_COLORS.one};
      margin-bottom: ${SPACING.one}px;

      svg {
        margin-left: ${SPACING.one}px;
      }
    }
  }
`;

export const AnimatedColumn = styled.td<{ expanded?: boolean }>`
  > div {
    display: flex;
    align-items: center;
    overflow: hidden;
    ${FONT_CSS.body.five}

    transition: all 0.2s ease-in-out;
    height: ${({ expanded }) => (expanded ? COMPONENTS.tableRow : 0)}px;
  }
`;

export const ExpiryColumn = styled(AnimatedColumn)`
  > div {
    align-items: center;
    color: ${TEXT_COLORS.two};
    margin-left: ${SPACING.three}px;
    padding-left: ${SPACING.four}px;
    border-left: 1px solid ${BORDER_COLORS.three};

    svg {
      margin-left: ${SPACING.one}px;
    }
  }
`;

export const PositionTitleWrapper = styled.div`
  height: 100%;
  display: flex;
  color: ${TEXT_COLORS.two};
  margin-left: ${SPACING.three + SPACING.four}px;
  padding-left: ${SPACING.four}px;
  border-left: 1px solid ${BORDER_COLORS.three};
`;

export const OptionNameTitle = styled.span`
  ${FONT_CSS.body.five}
  display: flex;
  align-items: center;
  color: ${TEXT_COLORS.one};
`;

export const OptionCell = styled.div``;
